import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=1328997e&scoped=true"
import script from "./IndexPage.vue?vue&type=script&lang=js"
export * from "./IndexPage.vue?vue&type=script&lang=js"
import style0 from "./IndexPage.vue?vue&type=style&index=0&id=1328997e&prod&lang=scss&scoped=true"
import style1 from "./IndexPage.vue?vue&type=style&index=1&id=1328997e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1328997e",
  null
  
)

export default component.exports